// Type-safe environment variable access

function getEnvVar(key: string): string {
  const value = import.meta.env[key]
  if (!value) {
    console.warn(`Environment variable ${key} is not set`)
    return ''
  }
  return value
}

export const env = {
  API_URL: getEnvVar('VITE_API_URL'),
  SUPABASE_URL: getEnvVar('VITE_SUPABASE_URL'),
  SUPABASE_ANON_KEY: getEnvVar('VITE_SUPABASE_ANON_KEY'),
  VIDEOS_URL: getEnvVar('VITE_VIDEOS_URL'),
} as const

// For development, provide defaults if not set
export const apiUrl = env.API_URL || 'http://localhost:8787'
export const videosUrl = env.VIDEOS_URL || 'http://localhost:8787/videos'
